<template>
<div>
		<header class="mdc-top-app-bar top-app-bar top-header">
		<div class="mdc-top-app-bar__row">
			<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
				<span class="mdc-top-app-bar__title t-subtitle4 pdl-12 cursor-pointer">{{title}}</span>
			</section>
			<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
				<div class=" t-body2 t-color-white pdr-18 cursor-pointer">
					<router-link tabindex="0" to="/login" class="t-body2 t-color-appbarText">{{$t('289')}}</router-link></div>
			</section>
		</div>
	</header>
	<div class="d-flex h-full flex-column">
		<main class="main-wrapper full flex-grow-1 scroll-y">

			<div class="container container--narrow pdt-50 ">
				<div class="border b-radius4 pda-36">
					<div class="t-headline10 font-b ">{{$t('1220')}}</div>
					<div class="mgt-24 bg-shadow2 h-2"></div>
				<div class="t-body1 t-color-bodyGrayA font-r pdt-24 t-line-h-26 l-spacing48" v-html="htmlTermsOfService">
				</div>
				</div>
				<div class="t-body3 t-color-bodyGrayA font-r mgt-24 pdr-24 ">
					{{$t('179')}} : {{termsDate}}
					<!-- {{$t('178',{'str1':year,'str2':month,'str3':day})}} -->
				</div>

				<div class="mgt-50 mgb-50 ">
					<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4" @click="back()" @keypress="back()" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('3315')}}</span>
					</button>
					<!-- <button class="mdc-button  t-color-secondaryBtnText b-radius4 mgl-8" @click="back()">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('3315')}}</span>
					</button> -->
				</div>
			</div>
		</main>
	</div>
</div>
</template>

<script>
/**
 * 이용약관 컴포넌트(terms and use Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import joinApi from '@/api/joinApi.js'

export default {
	components: {
		TopAppBar
	},
	data() {
		return {
			// title: '서비스 이용약관',
			title: null,
			htmlTermsOfService: null,
			year:'',
			month:'',
			day:'',
			termsDate:''
		}
	},

	mixins: [topAppBarMixin],
	methods : {
		back(){
			this.$router.go(-1);
		}
	},
	created(){
		this.title = localStorage.getItem('brandName') || this.$t('1220')
	},
	mounted() {
		this.setTopAppBarCloseOnly(this.title)

		// 약관정보 API 호출(call api terms and use)
		joinApi.terms().then((response) => {
			// console.log(response.data.data)
			const termsUrl = response.data.data.TERMS_OF_SERVICE;
			const privacyUrl = response.data.data.PRIVACY_STATEMENT;

			joinApi.policyContents(termsUrl,'text').then((response) => {
				this.htmlTermsOfService = response.data
			})
		}).catch((err) => {})

		let params = {type:'TERMS_OF_SERVICE'};
		joinApi.termsDate(params).then((response) => {
			if(response.data.data){
				this.termsDate = this.$moment(response.data.data).format("L")
				this.year = this.$moment(response.data.data).format("Y");
				this.month = this.$moment(response.data.data).format("MM");
				this.day = this.$moment(response.data.data).format("DD");
			}

		}).catch((err) => { console.log('err=>',err)})
	}

}
</script>
